export const MIN_SIDEBAR_WIDTH = 350
const MAX_SIDEBAR_WIDTH = 800
const MIN_WINDOW_WIDTH = 960

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const SIDEBAR_WIDTH_PROPORTION_FROM_DESIGN = 464 / 1200

export function getSidebarWidth(windowWidth: number, resizeDelta: number): number {
  return (
    Math.round(Math.max(windowWidth, MIN_WINDOW_WIDTH) * SIDEBAR_WIDTH_PROPORTION_FROM_DESIGN) +
    resizeDelta
  )
}

export function getMaxSidebarWidth(windowWidth: number) {
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  return Math.min(MAX_SIDEBAR_WIDTH, Math.max(windowWidth, MIN_WINDOW_WIDTH) - 200)
}
